module.exports = __webpack_public_path__ + "static/media/school_rank.edf0b9e3.csv";